// External
import update from "immutability-helper";

// Relative
import {
  TRIGGER_INTERNAL_TOOL_MODAL,
  CLOSE_INTERNAL_TOOL_MODAL,
} from "./InternalToolsModalConstants";

// Initial State
const initialState = {
  isOpen: false,
  type: "",
  data: {},
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [TRIGGER_INTERNAL_TOOL_MODAL]: (state, action) => {
    return update(state, {
      isOpen: { $set: true },
      type: { $set: action.payload.type },
      data: { $set: action.payload.data },
    });
  },
  [CLOSE_INTERNAL_TOOL_MODAL]: state => {
    return update(state, {
      isOpen: { $set: false },
      type: { $set: "" },
      data: { $set: {} },
    });
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
